import { ReactNode } from 'react'

import { PageLayout } from '@/components/layout/PageLayout'

export interface KnowledgePageShellProps {
  children: ReactNode
  /** Test ids are `${testId}-page` (the layout) and `${testId}-scroller`. */
  testId: string
  /** Rendered after the layout, outside the scroller (the page's dialogs). */
  overlays?: ReactNode
}

/**
 * The Library's full-page shell (the Topic page, a collection, the
 * collections list): one inner scroller, the sticky ancestor of a page's
 * smart bar, holding a centered 1440 px column. Its height and padding
 * classes are the only viewport breakpoints these pages use; everything
 * inside sizes by container queries. The column's gutters match the
 * Library page (24 px, 32 px from md), and its top padding plus a header
 * row's own `pt-5` puts the back link row where the Library's header sits,
 * so moving between the pages never shifts the column.
 */
export function KnowledgePageShell(props: KnowledgePageShellProps) {
  const { children, testId, overlays } = props

  return (
    <div className="bg-background">
      {/* Every breakpoint's padding reset: `PageLayout`'s own md and lg padding
          would otherwise stack on the column's gutters. */}
      <PageLayout className="max-w-none gap-0 p-0 md:p-0 lg:p-0" data-testid={`${testId}-page`}>
        {/* The one scroller: the sticky ancestor of the smart bar. */}
        <div
          className="h-[calc(100dvh-3.5rem-var(--feedback-manual-lane,0px))] overflow-y-auto md:h-[calc(100dvh-var(--feedback-manual-lane,0px))]"
          data-testid={`${testId}-scroller`}
        >
          <div className="mx-auto w-full max-w-[1440px] px-6 pb-24 pt-1 md:px-8 md:pt-3">{children}</div>
        </div>
      </PageLayout>
      {overlays}
    </div>
  )
}
